import { createAmazonApiInstance, createUploadFileFleetApiInstanceWithToken} from '../util';

const general = {
    uploadFile: ({ url, file, contentType }) => {
        return createAmazonApiInstance(url, {
            'Content-Type': contentType ?? file.type,
        }).put('', file);
    },
    importFileByPOST: ({url, file}) => {
        return createUploadFileFleetApiInstanceWithToken().post(url, file);
    },
};

export default general;
